<template>
  <v-container fluid fill-height class="background">
    <v-layout flex align-center justify-center>
      <v-flex xs12 sm4 elevation-6>
        <v-card>
          <v-card-title class="justify-center" style="font-size: 2em">Sign In</v-card-title>
          <v-card-text class="pt-4">
            <div>
              <v-form v-model="valid" ref="form">
                <v-text-field label="Enter your e-mail address" v-model="email" :rules="emailRules"
                  required></v-text-field>
                <v-text-field label="Enter your password" v-model="password"
                  :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'" @click:append="() => (e1 = !e1)"
                  :type="e1 ? 'text' : 'password'" :rules="passwordRules" required></v-text-field>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn block @click="submit" rounded color="success">Sign In</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar">
      {{ snackBarText }}

      <template>
        <v-btn color="blue" text @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "./baseUrl";
export default {
  name: "SignIn",
  data() {
    return {
      valid: false,
      e1: false,
      snackbar: false,
      snackBarText: "",
      password: "",
      passwordRules: [(v) => !!v || "Password is required"],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        //(v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        var data = {
          email: this.email,
          password: this.password,
        };
        let url = BASE_URL + "users/signin";
        axios
          .post(url, data)
          .then((response) => {
            if (response.status == 200) {
              if (response.data.response.hasError) {
                this.snackbar = true;
                this.snackBarText = response.data.response.message;
              } else {
                //console.log(response.data.response.role)
                const { token, role } = response.data.response;
                localStorage.setItem("token", token);
                localStorage.setItem("role", role);
                console.log(role)
                if (role == "messages") {
                  console.log("in")
                  this.$router.push({
                    path: "/messages",
                    meta: {
                      sidebar: true
                    },
                  });
                } else {
                  this.$router.push({
                    path: "/products",
                    meta: {
                      sidebar: true
                    },
                  });
                }
              }
            }
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
            this.errored = true;
          })
          .finally(() => (this.loading = false));
      }
    },
    clear() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
.background {
  background: url("../assets/loginbackground.jpg") no-repeat center center fixed;
  background-size: cover;
}
</style>